﻿module.exports = {
    "id": "fr",
    "label": "Français",
    "rtl": false,

    "translations": {
        "INVALID_LINK_TITLE":           "Lien Invalide",
        "INVALID_LINK_TEXT":            "Veuillez utiliser le lien de désinscription présent sur votre email pour être supprimé de nos listes de diffusion.",
        "UNSUBSCRIBE_ARE_YOU_SURE":     "êtes-vous sur de vouloir être supprimé de nos listes de diffusion?",
        "UNSUBSCRIBE_CLICK_CONFIRM":    "Cliquez sur le bouton \"Désinscription\" ci-dessous pour confirmer.",
        "YOU_HAVE_BEEN_UNSUBSCRIBED":   "Vous avez été <b>supprimé</b> de nos listes de diffusion.",
        "UNSUBSCRIBED_IN_ERROR": "Si vous avez été désinscrit par erreur cliquez sur le lien <a href='#' class='resubscribe' ng-click='resubscribe()'>Inscription</a>.",
        "CANCELLED_STILL_SUBSCRIBED":   "<b>Annuler.</b> Vous êtes toujours <b>inscrit</b> sur nos liste de diffusion.",
        "THANK_YOU_FOR_CONTINUING":     "Merci de continuer à prendre part à nos sondages.",
        "EMAIL_ALREADY_UNSUBSCRIBED":   "Cette adresse email a déjà été <b>supprimée</b> de nos liste de diffusion.",
        "CLICK_RESUBSCRIBE_TO_REJOIN": "Cliquez sur le bouton \"Inscription\" ci-dessous pour rejoindre nos liste de diffusion.",
        "YOU_HAVE_BEEN_RESUBSCRIBED":   "Vous avez été <b>réinscrit</b> sur nos listes de diffusion.",
        "YOU_ARE_ALREADY_SUBSCRIBED":   "Vous êtes déjà inscrit sur nos listes de diffusion.",
        "THANK_YOU_FOR_PARTICIPATING":  "Merci de prendre part à nos sondages.",
        "CHECKING":                     "Vérification en cours...",
        "UNSUBSCRIBE":                  "Désinscription",
        "RESUBSCRIBE":                  "Inscription",
        "EMAIL":                        "Email",
        "CANCEL":                       "Annuler"
    }
};


